import { api } from './../../api.js';
import { config } from './../../config.js';

const actions = {
    BACK_TEATRO_DIRECCIONES_FISCALES_INDEX : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.teatro.direcciones.fiscales.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_TEATRO_DIRECCIONES_FISCALES_STORE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.teatro.direcciones.fiscales.store'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_TEATRO_DIRECCIONES_FISCALES_EDIT : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.teatro.direcciones.fiscales.edit'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
}

export default {
    actions
};